import { Checkbox, FormControlLabel, Radio } from '@mui/material';
import { EditorState } from 'draft-js';
import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button } from 'src/components';
import Loader from 'src/components/loader';
import { fetchSetting } from 'src/redux/action/setting.action';
import { RootState } from 'src/redux/reducers';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';
import * as Yup from 'yup';

interface ServiceObj {
  id: string;
  name: string;
  isSelected: boolean;
  isSelectedForOnlineOrdering: boolean;
}

interface IProps {
  settingData?: {
    services: ServiceObj[];
  };
}

const FORM_VALIDATION = Yup.object().shape({});

// const services = [
//   {
//     id:0,
//     title : 'Food menu'
//   },
//   {
//     id:0,
//     title : 'Amenities'
//   },
//   {
//     id:0,
//     title : 'Activity'
//   },
//   {
//     id:0,
//     title : 'Wellness'
//   },
//   {
//     id:0,
//     title : 'Food menu'
//   },
//   {
//     id:0,
//     title : 'Souvenir'
//   }
// ]

const ServicesTab: React.FC<IProps> = () => {
  const { settingData, loading, error } = useSelector(
    ({ settingData }: RootState) => settingData,
    shallowEqual
  );
  const services = settingData?.settings?.services ?? [];

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (settingData?.businessInfo?.length > 0) return;
    dispatch(fetchSetting() as any);
  }, [dispatch]);

  const [ischecked, setIsChecked] = useState<boolean[]>([]);
  const [isSelectedForOnlineOrdering, setIsSelectedForOnlineOrdering] =
    useState('');
  useEffect(() => {
    const selected =
      settingData.settings?.services?.map((service: ServiceObj) =>
        service.isSelected ? true : false
      ) ?? [];
    setIsChecked(selected);
    const selectedForOnlineOrdering = settingData.settings?.services?.find(
      (service: ServiceObj) => service.isSelectedForOnlineOrdering === true
    )?.id;
    setIsSelectedForOnlineOrdering(selectedForOnlineOrdering);
  }, [settingData]);

  const handleCheck = (index: number) => {
    const checkedArr = [...ischecked];
    checkedArr[index] = !ischecked[index];
    setIsChecked(checkedArr);
  };

  const handleSubmitBusiness = async (values: any, { resetForm }: any) => {
    const filteredArray = services
      .filter((_: any, index: number) => ischecked[index])
      .map((item: any) => ({
        id: item.id,
        isSelectedForOnlineOrdering: item.id === isSelectedForOnlineOrdering,
      }));
    const payload = {
      businessId: settingData?.businessInfo?.id,
      services: filteredArray,
    };
    try {
      await Service.post('services/assign', payload);
      toastAlert('success', `Service updated`);
      dispatch(fetchSetting() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsSelectedForOnlineOrdering((event.target as HTMLInputElement).value);
  };

  const renderSwitch = (each: any, i: number) => (
    <div className="flex justify-between">
      <div className="flex flex-col">
        <span>{each.name}</span>
        {ischecked[i] && (
          <FormControlLabel
            className="text-secondary-0 text-sm"
            value="female"
            control={
              <Radio
                size="small"
                value={each.id}
                checked={each.id === isSelectedForOnlineOrdering}
                onChange={handleChange}
              />
            }
            label="Enable in online ordering app"
          />
        )}
      </div>
      <label className="toggle inline-block w-12 h-6 bg-gray-100 rounded-full border-2 border-light-gray relative cursor-pointer">
        <div
          className={`absolute w-6 h-6 rounded-[50%] -top-[2px] -left-[2px] bg-light-gray transition-transform duration-500 ${
            ischecked[i] ? 'transform translate-x-full bg-primary' : ''
          }`}
        ></div>
        <input
          type="checkbox"
          className="hidden"
          checked={ischecked[i]}
          onChange={(e) => handleCheck(i)}
        />
      </label>
    </div>
  );

  return (
    <div>
      {loading ? (
        <Loader className="settings" />
      ) : (
        <Formik
          initialValues={{}}
          validateOnMount
          validationSchema={FORM_VALIDATION}
          onSubmit={handleSubmitBusiness}
        >
          {({ isValid, isSubmitting, setFieldValue }) => (
            <Form>
              <div className="relative">
                <div className="flex flex-col gap-6">
                  {services?.map(renderSwitch)}
                </div>
              </div>
              <div className="flex items-center justify-end mt-6">
                <Button
                  text="save Details"
                  variant="primary"
                  type="submit"
                  isSubmitting={isSubmitting}
                  isValid={isValid}
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default React.memo(ServicesTab);
